import React, { useEffect, useState } from "react";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import CustomTable from "../../../components/table/table";
import {
  admin_location_list,
  admin_spacearea_create,
  admin_spacearea_delete,
  admin_spacearea_list,
  admin_spacearea_update,
} from "../admin.api";
import ManageArea from "./manage/manage";
import "./view.css";
import jwtDecode from "jwt-decode";

export default function View(props) {
  const [locationData, setLocationData] = useState([]);
  const [baseLocationData, setBaseLocationData] = useState([]);
  const [spaceLocationData, setSpaceLocationData] = useState([]);
  const [snackMessage, setSnackMessage] = useState("");
  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const [areaType, setAreaType] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [openAction, setOpenAction] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [formData, setFormData] = useState({});
  const [edit, setEdit] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [view, setView] = useState(false);
  const [selectedLocationId, setSelectedLocationId] = useState("");
  const [subLocation, setSubLocation] = useState("");

  const fetchLocation = () => {
    setIsActive(true);
    admin_location_list().then((res) => {
      let tdata = res.data;
      setLocationData(tdata);
      setIsActive(false);
    });
  };

  const fetchSpaceLocation = () => {
    setIsActive(true);
    const params = {};
    if (selectedLocationId) params.location_id = selectedLocationId;
    if (subLocation) params.sub_location = subLocation;
    admin_spacearea_list(params).then((res) => {
      setSpaceLocationData(res.data);
      setIsActive(false);
    });
  };
  const onInit = () => {
    fetchLocation();

    fetchSpaceLocation();
  };
  const handleAddNew = (e, value) => {
    setAddNew(true);
    setView(false);
    setAreaType(value);
  };

  const handleClose = (id) => {
    setAddNew(false);
    setEdit(false);
    setAreaType("");
    setFormData({});
    if (id) {
      fetchSpaceLocation();
    }
  };
  const handleView = (data) => {
    setAreaType("builtup");
    setFormData(data);
    setAddNew(true);
    setView(true);
  };

  const handleEdit = (data) => {
    setAreaType("builtup");
    setFormData(data);
    setView(false);
    setEdit(true);
    setAddNew(true);
  };

  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    admin_spacearea_delete(data.uuid)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
      });
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      fetchSpaceLocation();
      setAddNew(false);
      setEdit(false);
      setFormData({});
    }
  };
  useEffect(() => {
    onInit();
  }, []);
  const onSearch = () => {
    //
  };
  const handleFilterApply = () => {
    fetchSpaceLocation();
  };
  const handleFilterClear = () => {
    setSelectedLocationId("");
    setSubLocation("");
    setAreaType("");
    // refetch without filters
    setTimeout(() => fetchSpaceLocation(), 0);
  };
  const handlesubmit = (id, data) => {
    const promise = edit
      ? admin_spacearea_update(id, data)
      : admin_spacearea_create(data);

    return promise
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setAreaType("");
        return res;
      })
      .catch((error) => {
        setSnackMessage(error.message || "Something went wrong");
        setIsSnackError(true);
        setSnackOpen(true);
        throw error;
      });
  };

  let columns = [];

  if (areaType === "land-on") {
    columns = [
      {
        title: "Location",
        field: "locations.locations",
        render: (rowData) => rowData.locations?.locations || "",
      },
      { title: "Sub Location", field: "sub_location" },
      {
        title: "Category",
        field: "areasubs.area_type_caption",
        render: (rowData) =>
          rowData.areasubs?.area_type_caption === "built-up"
            ? "BUILT-UP SPACE"
            : "LAND" || "",
      },
      {
        title: "Type",
        render: (rowData) => rowData?.built_space_type?.name || "",
      },
      { title: "Total Area in cent", field: "area_in_acres" },
      { title: "Allotted Area", field: "total_allocated" },
      { title: "Remaining Area", field: "available_area" },
      {
        title: "Base Premium (Rupees/cent)",
        field: "rupees_in_lakhs_or_acres",
      },
    ];
  } else if (areaType === "built-up") {
    columns = [
      {
        title: "Location",
        field: "locations.locations",
        render: (rowData) => rowData.locations?.locations || "",
      },
      // { title: "Sub Location", field: "sub_location" },
      {
        title: "Category",
        field: "areasubs.area_type_caption",
        render: (rowData) =>
          rowData.areasubs?.area_type_caption === "built-up"
            ? "BUILT-UP SPACE"
            : "LAND" || "",
      },
      {
        title: "Type",
        render: (rowData) => rowData?.built_space_type?.name || "",
      },
      { title: "Sub Location", field: "sub_location" },
      { title: "Total Area (in sq.ft)", field: "area_in_sqft" },
      { title: "Allotted Area", field: "total_allocated" },
      { title: "Remaining Area", field: "available_area" },
      { title: "Base Price (Rupees/sqft)", field: "rupees_in_sqft" },
    ];
  } else {
    // All tab (default)
    columns = [
      {
        title: "Location",
        field: "locations.locations",
        render: (rowData) => rowData.locations?.locations || "",
      },
      { title: "Sub Location", field: "sub_location" },

      // { title: "Sub Location", field: "sub_location" },
      {
        title: "Category",
        field: "areasubs.area_type_caption",
        render: (rowData) =>
          rowData.areasubs?.area_type_caption === "built-up"
            ? "BUILT-UP SPACE"
            : "LAND" || "",
      },
      {
        title: "Type",
        render: (rowData) => rowData?.built_space_type?.name || "",
      },
      { title: "Total Area (in sq.ft)", field: "area_in_sqft" },
      { title: "Allotted Area", field: "total_allocated" },
      { title: "Remaining Area", field: "available_area" },
      { title: "Base Price (Rupees/sqft)", field: "rupees_in_sqft" },
      { title: "Total Area (in cent)", field: "area_in_acres" },
      {
        title: "Base Premium (Rupees/cent)",
        field: "rupees_in_lakhs_or_acres",
      },
    ];
  }

  return (
    <div>
      <Loader open={isActive} />
      <div className="view-container">
        <h6>
          <b>Built-Up Space/Land in KSPACE Premises</b>
        </h6>
        <hr />
        <div className="d-flex justify-content-between align-items-center mb-3">
          {adminType === 1 && (
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={(e) => handleAddNew(e, "builtup")}
            >
              Add New
            </button>
          )}
          <div className="d-flex gap-2 align-items-center">
            <select
              className="form-select form-select-sm w-auto"
              value={areaType}
              onChange={(e) => setAreaType(e.target.value)}
            >
              <option value="">All</option>
              <option value="built-up">Built-up Space</option>
              <option value="land-on">Land On Lease</option>
            </select>

            <select
              className="form-select form-select-sm w-auto"
              value={selectedLocationId}
              onChange={(e) => setSelectedLocationId(e.target.value)}
            >
              <option value="">All Locations</option>
              {locationData.map((loc) => (
                <option key={loc.id} value={loc.id}>
                  {loc.locations}
                </option>
              ))}
            </select>

            <input
              className="form-control form-control-sm"
              style={{ width: 220 }}
              type="text"
              placeholder="Filter Sub Location"
              value={subLocation}
              onChange={(e) => setSubLocation(e.target.value)}
            />

            <button
              className="btn btn-sm btn-primary"
              onClick={handleFilterApply}
            >
              Apply
            </button>
            <button
              className="btn btn-sm btn-secondary"
              onClick={handleFilterClear}
            >
              Clear
            </button>
          </div>
        </div>
        {/* )} */}
        <CustomTable
          {...props}
          // columns={[
          //   {
          //     title: "Location",
          //     field: "locations.locations",
          //     render: (rowData) => rowData.locations?.locations || "",
          //   },
          //   { title: "Sub Location", field: "sub_location" },
          //   { title: "Area in sq.ft", field: "area_in_sqft" },
          //   { title: "Base Price (Rupees/sqft)", field: "rupees_in_sqft" },
          //   { title: "Rupees / cent", field: "rupees_in_lakhs_or_acres" },
          //   { title: "Area in cent", field: "area_in_acres" },
          // ]}
          columns={columns}
          data={
            areaType
              ? spaceLocationData.filter(
                  (item) => item?.areasubs?.type === areaType,
                )
              : spaceLocationData
          }
          actions={
            adminType === 2
              ? [
                  { type: "view", handleClick: handleView },
                  { type: "delete", handleClick: handleDelete },
                ]
              : adminType === 23
                ? [{ type: "view", handleClick: handleView }]
                : [
                    { type: "view", handleClick: handleView },
                    { type: "edit", handleClick: handleEdit },
                  ]
          }
        />
        <br />
      </div>
      {addNew && (
        <ManageArea
          open={addNew}
          edit={edit}
          areaType={areaType}
          view={view}
          handleClose={handleClose}
          formData={formData}
          areaId={1}
          locationData={locationData}
          submit={handlesubmit}
        />
      )}
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete This Area ?"
          data={activeData}
          message="Are you sure to delete this area?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
